import Vue from "vue";
import "@/services/axios";

export default {
  get(endpoint) {
    return Vue.$http.get(`${endpoint}`);
  },
  getById(endpoint, id) {
    return Vue.$http.get(`${endpoint}/${id}`);
  },
  put(endpoint, id, data) {
    return Vue.$http.put(`${endpoint}/${id}`, data);
  },
  post(endpoint, data) {
    return Vue.$http.post(`${endpoint}`, data);
  }
};
